module.exports = __webpack_public_path__ + "51d4b21e8b8a03b7b5b6fb3681edbabf.woff2";